var _path, _g, _path2, _path3, _path4, _path5, _path6, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgMd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2285,
    height: 674,
    viewBox: "0 0 2285 674",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M934.391 32.9735C1051.64 374.422 1585.31 406.018 1867.5 406.018H2252C2252.27 406.018 2252.42 406.229 2252.42 406.494V672.608C2252.42 672.873 2252.2 673.072 2251.94 673.072H1.7703C1.50566 673.072 1.29102 672.857 1.29102 672.593V406.497C1.29102 406.232 1.49407 406.018 1.75871 406.018C290.655 405.984 816.296 374.238 933.467 32.9738C933.616 32.5408 934.242 32.5405 934.391 32.9735Z",
    fill: "#FAFAFA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_34_394)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.3965 405.371C685.28 405.371 874.451 195.067 933.99 34.4956C993.625 195.067 1183.1 405.371 1836.02 405.371H2251.7",
    stroke: "url(#paint0_linear_34_394)",
    strokeWidth: 2.875,
    strokeLinecap: "round"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M933.99 44.0791L934.214 43.9947L933.99 43.3983L933.766 43.9948L933.99 44.0791ZM33.3965 408.006C33.2642 408.006 33.1569 408.113 33.1569 408.246C33.1569 408.378 33.2642 408.485 33.3965 408.485V408.006ZM2237.32 408.485C2237.46 408.485 2237.56 408.378 2237.56 408.246C2237.56 408.113 2237.46 408.006 2237.32 408.006V408.485ZM1836.02 408.006C1509.58 408.006 1299.02 356.589 1162.63 285.382C1026.25 214.18 964.012 123.185 934.214 43.9947L933.766 44.1635C963.603 123.46 1025.92 214.548 1162.41 285.807C1298.9 357.062 1509.54 408.485 1836.02 408.485V408.006ZM33.3965 408.485C359.36 408.485 569.666 357.062 705.934 285.807C842.208 214.548 904.425 123.46 934.215 44.1634L933.766 43.9948C904.016 123.185 841.878 214.18 705.711 285.383C569.537 356.589 359.316 408.006 33.3965 408.006V408.485ZM1836.02 408.485H2237.32V408.006H1836.02V408.485Z",
    fill: "url(#paint1_linear_34_394)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M933.99 51.2666L934.125 51.216L933.99 50.8582L933.856 51.216L933.99 51.2666ZM33.3965 410.019C33.3171 410.019 33.2527 410.083 33.2527 410.162C33.2527 410.242 33.3171 410.306 33.3965 410.306V410.019ZM2239.72 410.306C2239.8 410.306 2239.86 410.242 2239.86 410.162C2239.86 410.083 2239.8 410.019 2239.72 410.019V410.306ZM1836.02 410.019C1509.57 410.019 1299 359.914 1162.59 290.013C1026.18 220.115 963.93 130.419 934.125 51.216L933.856 51.3172C963.685 130.585 1025.99 220.337 1162.46 290.269C1298.92 360.198 1509.55 410.306 1836.02 410.306V410.019ZM33.3965 410.306C359.351 410.306 569.64 360.198 705.888 290.269C842.141 220.337 904.343 130.585 934.125 51.3172L933.856 51.216C904.098 130.419 841.945 220.115 705.757 290.013C569.564 359.914 359.326 410.019 33.3965 410.019V410.306ZM1836.02 410.306H2239.72V410.019H1836.02V410.306Z",
    fill: "url(#paint2_linear_34_394)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M936.066 113.993C936.091 113.701 936.519 113.701 936.544 113.993L949.682 269.769C949.844 271.689 950.344 273.566 951.159 275.313L997.232 374.077C997.356 374.344 996.984 374.556 996.818 374.314L941.042 293.243C938.757 289.922 933.853 289.922 931.568 293.243L875.793 374.314C875.626 374.556 875.254 374.344 875.378 374.077L921.451 275.313C922.266 273.566 922.766 271.689 922.928 269.769L936.066 113.993Z",
    fill: "url(#paint3_linear_34_394)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M923.776 267.143L926.715 232.39C926.807 231.301 928.33 231.128 928.664 232.169L951.977 304.906C952.328 306.001 950.856 306.726 950.202 305.779L923.95 267.796C923.818 267.605 923.757 267.374 923.776 267.143Z",
    fill: "url(#paint4_linear_34_394)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M911.275 357.143C888.63 422.234 854.411 511.537 712.503 567.51",
    stroke: "url(#paint5_linear_34_394)",
    strokeWidth: 0.414108
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 848.818,
    y: 336.699,
    width: 7.48586,
    height: 0.479167,
    rx: 0.239583,
    transform: "rotate(135 848.818 336.699)",
    fill: "url(#paint6_linear_34_394)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 7.48586,
    height: 0.533228,
    rx: 0.266614,
    transform: "matrix(0.707107 0.707107 0.707107 -0.707107 1026.52 338.137)",
    fill: "url(#paint7_linear_34_394)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 4.34708,
    height: 0.479167,
    rx: 0.239583,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 834.583 350.932)",
    fill: "url(#paint8_linear_34_394)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 1.079,
    height: 0.479167,
    rx: 0.239583,
    transform: "matrix(0.707024 -0.70719 -0.707024 -0.70719 831.269 354.248)",
    fill: "url(#paint9_linear_34_394)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 4.34708,
    height: 0.533228,
    rx: 0.266614,
    transform: "matrix(-0.707079 -0.707135 0.707079 -0.707135 1040.76 352.37)",
    fill: "url(#paint10_linear_34_394)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 1043.42,
    y: 355.031,
    width: 0.635987,
    height: 0.533228,
    rx: 0.266614,
    transform: "rotate(-135 1043.42 355.031)",
    fill: "url(#paint11_linear_34_394)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1019.92 331.49L974.648 286.221C968.827 280.4 965.043 272.854 963.859 264.707L946.474 145.059",
    stroke: "url(#paint12_linear_34_394)",
    strokeWidth: 0.533228,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M853.823 331.49L899.091 286.221C904.912 280.4 908.697 272.854 909.88 264.707L927.265 145.059",
    stroke: "url(#paint13_linear_34_394)",
    strokeWidth: 0.479167
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M902.408 223.021L911.447 172.176",
    stroke: "url(#paint14_linear_34_394)",
    strokeWidth: 0.479167,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M978.111 262.567L971.332 221.892",
    stroke: "url(#paint15_linear_34_394)",
    strokeWidth: 0.414108,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M964.552 193.644L962.292 177.826",
    stroke: "url(#paint16_linear_34_394)",
    strokeWidth: 0.414108,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M921.616 126.98L922.746 120.201",
    stroke: "url(#paint17_linear_34_394)",
    strokeWidth: 0.479167,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M951.48 335.892C971.718 388.298 1026.02 481.244 1114.22 528.038",
    stroke: "url(#paint18_linear_34_394)",
    strokeWidth: 0.414108
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M875.809 530.34C859.001 560.394 838.739 582.827 822.104 600.222",
    stroke: "url(#paint19_linear_34_394)",
    strokeWidth: 0.414108
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1009 291.973C1023.77 308.912 1029.29 314.274 1039.03 322.675",
    stroke: "url(#paint20_linear_34_394)",
    strokeWidth: 0.414108
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1043.96 531.871C1059.09 558.401 1099.7 605.453 1165.67 629.142",
    stroke: "url(#paint21_linear_34_394)",
    strokeWidth: 0.414108
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M960.259 50.4863C997.476 136.559 1090.98 220.746 1168.65 260.28",
    stroke: "url(#paint22_linear_34_394)",
    strokeWidth: 0.479167
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M903.787 50.4863C873.375 137.038 773.066 220.746 695.4 260.28",
    stroke: "url(#paint23_linear_34_394)",
    strokeWidth: 0.479167
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1524.26 371.083C1524.35 371.123 1524.43 371.179 1524.49 371.238C1524.55 371.303 1524.61 371.384 1524.65 371.471C1524.68 371.56 1524.71 371.653 1524.72 371.77C1524.73 371.885 1524.72 372.011 1524.69 372.153L1524.66 372.369C1524.54 373.054 1524.15 373.334 1523.45 373.22L1521.13 372.825C1521.13 372.825 1521.31 371.763 1521.49 370.703C1521.68 369.641 1521.86 368.582 1521.86 368.582L1524.05 368.953C1524.74 369.069 1525.02 369.474 1524.9 370.162L1524.89 370.243C1524.85 370.479 1524.78 370.668 1524.68 370.804C1524.58 370.945 1524.45 371.033 1524.26 371.083ZM1522.04 371.079L1521.82 372.33L1523.53 372.622C1523.7 372.649 1523.82 372.636 1523.9 372.565C1523.98 372.509 1524.04 372.395 1524.07 372.233L1524.12 371.902C1524.15 371.744 1524.13 371.618 1524.08 371.536C1524.02 371.451 1523.91 371.398 1523.75 371.367L1522.04 371.079ZM1522.35 369.281L1522.14 370.482L1523.77 370.764C1523.92 370.784 1524.03 370.758 1524.11 370.694C1524.18 370.634 1524.23 370.526 1524.26 370.367L1524.31 370.094C1524.33 369.932 1524.32 369.807 1524.26 369.718C1524.2 369.632 1524.09 369.576 1523.93 369.549L1522.35 369.281Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1525.92 369.273L1526.53 369.37C1526.53 369.37 1526.38 370.285 1526.23 371.189C1526.08 372.104 1525.93 373.015 1525.93 373.015L1528.36 373.409C1528.36 373.409 1528.51 372.501 1528.66 371.589C1528.8 370.684 1528.95 369.77 1528.95 369.77L1529.56 369.869C1529.56 369.869 1529.41 370.781 1529.26 371.689C1529.11 372.601 1528.97 373.513 1528.97 373.513C1528.95 373.597 1528.92 373.669 1528.88 373.743C1528.84 373.811 1528.78 373.867 1528.72 373.912C1528.65 373.96 1528.58 373.993 1528.5 374.008C1528.42 374.03 1528.34 374.036 1528.26 374.016L1525.82 373.619C1525.74 373.603 1525.67 373.578 1525.59 373.529C1525.53 373.491 1525.47 373.432 1525.42 373.369C1525.38 373.306 1525.35 373.234 1525.32 373.159C1525.31 373.075 1525.3 372.992 1525.32 372.908C1525.32 372.908 1525.47 372 1525.62 371.089C1525.77 370.181 1525.92 369.273 1525.92 369.273Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1531.07 370.116C1531.07 370.116 1530.9 371.176 1530.73 372.24C1530.56 373.3 1530.39 374.364 1530.39 374.364L1529.78 374.264C1529.78 374.264 1529.96 373.204 1530.13 372.14C1530.3 371.076 1530.47 370.019 1530.47 370.019L1531.07 370.116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1532.59 370.356C1532.59 370.356 1532.45 371.264 1532.3 372.176C1532.16 373.088 1532.01 374 1532.01 374L1534.21 374.344L1534.11 374.948C1534.11 374.948 1533.41 374.842 1532.71 374.731C1532.01 374.618 1531.31 374.508 1531.31 374.508C1531.31 374.508 1531.48 373.447 1531.64 372.387C1531.82 371.32 1531.98 370.259 1531.98 370.259L1532.59 370.356Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1534.22 370.614C1534.22 370.614 1535.07 370.744 1535.92 370.877C1536.77 371.007 1537.62 371.133 1537.62 371.133L1537.53 371.742L1536.13 371.532C1536.13 371.532 1535.99 372.445 1535.85 373.354C1535.71 374.263 1535.57 375.179 1535.57 375.179L1534.96 375.085C1534.96 375.085 1535.1 374.173 1535.24 373.26C1535.39 372.352 1535.53 371.436 1535.53 371.436L1534.13 371.223L1534.22 370.614Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1542.92 375.648C1542.91 375.732 1542.88 375.811 1542.84 375.883C1542.8 375.95 1542.75 376.006 1542.68 376.058C1542.62 376.106 1542.54 376.136 1542.47 376.158C1542.39 376.177 1542.3 376.182 1542.22 376.173L1539.78 375.809C1539.69 375.796 1539.62 375.775 1539.55 375.726C1539.48 375.691 1539.42 375.637 1539.38 375.573C1539.33 375.506 1539.29 375.433 1539.27 375.359C1539.25 375.275 1539.25 375.199 1539.26 375.11C1539.26 375.11 1539.38 374.354 1539.49 373.593C1539.6 372.835 1539.72 372.071 1539.72 372.071C1539.72 371.993 1539.76 371.914 1539.79 371.85C1539.84 371.775 1539.89 371.719 1539.96 371.672C1540.02 371.627 1540.09 371.589 1540.17 371.57C1540.25 371.548 1540.33 371.543 1540.41 371.556L1542.84 371.911C1542.93 371.924 1543 371.949 1543.06 371.997C1543.14 372.04 1543.19 372.09 1543.25 372.154C1543.29 372.218 1543.32 372.29 1543.35 372.368C1543.37 372.449 1543.37 372.529 1543.36 372.61C1543.36 372.61 1543.25 373.367 1543.14 374.129C1543.03 374.886 1542.92 375.648 1542.92 375.648ZM1540.32 372.164C1540.32 372.164 1540.21 372.925 1540.09 373.686C1539.98 374.443 1539.87 375.2 1539.87 375.2L1542.31 375.565C1542.31 375.565 1542.42 374.8 1542.53 374.042C1542.64 373.281 1542.75 372.517 1542.75 372.517L1540.32 372.164Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1544.36 376.48L1543.75 376.386C1543.75 376.386 1543.9 375.324 1544.05 374.258C1544.21 373.193 1544.36 372.13 1544.36 372.13L1544.97 372.217C1544.97 372.217 1545.49 373.132 1546.02 374.044C1546.54 374.963 1547.07 375.883 1547.07 375.883C1547.07 375.883 1547.18 375.053 1547.3 374.224C1547.41 373.402 1547.52 372.572 1547.52 372.572L1548.13 372.662C1548.13 372.662 1547.98 373.728 1547.84 374.791C1547.69 375.858 1547.54 376.92 1547.54 376.92L1546.93 376.841C1546.93 376.841 1546.4 375.921 1545.88 375.006C1545.36 374.09 1544.84 373.171 1544.84 373.171C1544.84 373.171 1544.72 374 1544.6 374.826C1544.48 375.651 1544.36 376.48 1544.36 376.48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1552.57 373.263C1552.57 373.263 1552.84 374.381 1553.11 375.507C1553.38 376.625 1553.65 377.747 1553.65 377.747L1553.04 377.666L1552.8 376.63L1550.86 376.373L1550.36 377.308L1549.74 377.227C1549.74 377.227 1550.3 376.215 1550.85 375.2C1551.4 374.188 1551.96 373.18 1551.96 373.18L1552.57 373.263ZM1551.18 375.796L1552.64 375.991L1552.16 374.019L1551.18 375.796Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1554.82 377.897L1554.21 377.813C1554.21 377.813 1554.34 376.746 1554.48 375.679C1554.62 374.619 1554.76 373.551 1554.76 373.551L1555.37 373.628C1555.37 373.628 1555.9 374.537 1556.44 375.444C1556.98 376.354 1557.51 377.264 1557.51 377.264C1557.51 377.264 1557.62 376.437 1557.72 375.607C1557.83 374.784 1557.93 373.956 1557.93 373.956L1558.54 374.033C1558.54 374.033 1558.41 375.1 1558.27 376.168C1558.14 377.236 1558.01 378.304 1558.01 378.304L1557.39 378.22C1557.39 378.22 1556.85 377.313 1556.31 376.406C1555.78 375.496 1555.25 374.583 1555.25 374.583C1555.25 374.583 1555.14 375.413 1555.03 376.24C1554.92 377.066 1554.82 377.897 1554.82 377.897Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1561.18 378.073C1561.46 378.103 1561.69 378.056 1561.86 377.92C1562.03 377.787 1562.14 377.579 1562.17 377.294L1562.32 376.012C1562.34 375.873 1562.34 375.748 1562.31 375.629C1562.29 375.516 1562.23 375.414 1562.17 375.335C1562.1 375.249 1562.02 375.178 1561.91 375.125C1561.81 375.073 1561.68 375.035 1561.55 375.02L1559.98 374.827C1559.98 374.827 1559.89 375.591 1559.8 376.357C1559.7 377.119 1559.61 377.879 1559.61 377.879L1561.18 378.073ZM1558.92 378.412C1558.92 378.412 1559.06 377.345 1559.19 376.277C1559.32 375.212 1559.45 374.145 1559.45 374.145L1561.62 374.407C1561.85 374.435 1562.05 374.494 1562.22 374.592C1562.4 374.683 1562.54 374.802 1562.66 374.949C1562.77 375.095 1562.86 375.262 1562.9 375.456C1562.95 375.646 1562.96 375.857 1562.94 376.078L1562.78 377.363C1562.75 377.59 1562.7 377.797 1562.6 377.969C1562.51 378.148 1562.39 378.29 1562.24 378.407C1562.1 378.519 1561.93 378.604 1561.74 378.655C1561.54 378.696 1561.33 378.711 1561.1 378.683L1558.92 378.412Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1565.55 374.873C1565.55 374.873 1566.33 374.961 1567.1 375.055C1567.88 375.143 1568.66 375.227 1568.66 375.227L1568.59 375.842L1566.09 375.554L1565.95 376.776L1568.09 377.017L1568.02 377.635L1565.88 377.393L1565.67 379.219L1565.06 379.149C1565.06 379.149 1565.18 378.083 1565.3 377.011C1565.43 375.942 1565.55 374.873 1565.55 374.873Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1572.61 379.368C1572.59 379.456 1572.57 379.533 1572.53 379.608C1572.49 379.675 1572.44 379.735 1572.38 379.787C1572.32 379.832 1572.25 379.869 1572.17 379.891C1572.09 379.917 1572 379.925 1571.93 379.913L1569.47 379.648C1569.39 379.639 1569.31 379.62 1569.23 379.577C1569.17 379.539 1569.11 379.485 1569.06 379.427C1569.01 379.361 1568.97 379.295 1568.95 379.22C1568.92 379.138 1568.92 379.055 1568.92 378.973C1568.92 378.973 1569.01 378.206 1569.1 377.446C1569.18 376.682 1569.26 375.914 1569.26 375.914C1569.28 375.833 1569.3 375.761 1569.34 375.686C1569.38 375.615 1569.43 375.558 1569.49 375.506C1569.56 375.455 1569.63 375.418 1569.7 375.395C1569.78 375.37 1569.86 375.364 1569.95 375.37L1572.39 375.637C1572.46 375.642 1572.54 375.672 1572.61 375.714C1572.69 375.752 1572.75 375.8 1572.79 375.867C1572.84 375.924 1572.88 375.994 1572.91 376.075C1572.92 376.153 1572.94 376.23 1572.93 376.311C1572.93 376.311 1572.85 377.079 1572.77 377.843C1572.69 378.607 1572.61 379.368 1572.61 379.368ZM1569.88 375.981C1569.88 375.981 1569.8 376.745 1569.71 377.512C1569.63 378.276 1569.54 379.04 1569.54 379.04L1571.99 379.302C1571.99 379.302 1572.07 378.537 1572.16 377.774C1572.24 377.013 1572.32 376.245 1572.32 376.245L1569.88 375.981Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1577.13 377.676C1577.07 378.278 1576.78 378.59 1576.26 378.619L1576.89 380.43L1576.22 380.363L1575.6 378.575L1574.25 378.429L1574.07 380.145L1573.46 380.082C1573.46 380.082 1573.57 379.009 1573.68 377.941C1573.79 376.868 1573.91 375.802 1573.91 375.802L1576.25 376.045C1576.94 376.109 1577.25 376.494 1577.18 377.19L1577.13 377.676ZM1574.32 377.821L1576.01 377.998C1576.18 378.013 1576.3 377.985 1576.38 377.928C1576.46 377.864 1576.51 377.749 1576.52 377.586L1576.57 377.161C1576.58 376.995 1576.56 376.875 1576.5 376.796C1576.43 376.714 1576.31 376.666 1576.15 376.65L1574.46 376.473L1574.32 377.821Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1592.18 375.687C1592.18 375.687 1592.15 376.095 1592.1 376.712C1592.05 377.325 1591.98 378.145 1591.91 378.966C1591.84 379.783 1591.78 380.604 1591.72 381.217C1591.67 381.833 1591.64 382.245 1591.64 382.245L1590.31 382.135C1590.31 382.135 1590.34 381.723 1590.39 381.107C1590.44 380.493 1590.51 379.673 1590.58 378.853C1590.65 378.032 1590.71 377.212 1590.77 376.599C1590.82 375.983 1590.86 375.578 1590.86 375.578L1592.18 375.687Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1597.41 378.246C1597.41 378.246 1597.33 379.353 1597.25 380.461C1597.16 381.572 1597.08 382.679 1597.08 382.679C1597.03 383.368 1596.71 383.901 1596.25 384.249C1595.79 384.602 1595.18 384.766 1594.53 384.712C1593.89 384.664 1593.36 384.424 1592.98 384.056C1592.6 383.689 1592.38 383.191 1592.38 382.634L1593.7 382.754C1593.72 383.223 1594.12 383.469 1594.67 383.511C1595.18 383.546 1595.68 383.312 1595.74 382.59L1595.78 382.027C1595.43 382.223 1594.98 382.318 1594.49 382.276C1593.89 382.231 1593.36 381.94 1593 381.516C1592.63 381.099 1592.43 380.545 1592.48 379.98C1592.53 379.319 1592.82 378.786 1593.24 378.431C1593.67 378.078 1594.23 377.895 1594.83 377.943C1595.32 377.985 1595.74 378.148 1596.07 378.389L1596.09 378.154L1597.41 378.246ZM1595.88 380.757L1595.96 379.676C1595.73 379.255 1595.37 379.093 1594.99 379.063C1594.33 379.012 1593.85 379.417 1593.79 380.084C1593.75 380.581 1594.17 381.145 1594.82 381.202C1595.2 381.235 1595.59 381.13 1595.88 380.757Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1602.56 380.795C1602.51 381.477 1602.22 382.043 1601.77 382.427C1601.32 382.811 1600.71 383.01 1600.04 382.961C1599.36 382.912 1598.78 382.626 1598.39 382.185C1598 381.741 1597.79 381.138 1597.84 380.453C1597.9 379.775 1598.19 379.205 1598.64 378.818C1599.09 378.433 1599.69 378.231 1600.37 378.28C1601.05 378.326 1601.61 378.614 1602 379.062C1602.39 379.509 1602.6 380.113 1602.56 380.795ZM1601.27 380.7C1601.32 380.056 1600.93 379.509 1600.29 379.46C1599.63 379.413 1599.18 379.903 1599.13 380.547C1599.08 381.209 1599.46 381.731 1600.12 381.782C1600.77 381.814 1601.22 381.361 1601.27 380.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1610.95 379.158C1610.95 379.158 1610.89 380.264 1610.82 381.37C1610.76 382.473 1610.7 383.575 1610.7 383.575L1609.38 383.502L1609.4 383.26C1609.05 383.455 1608.6 383.572 1608.11 383.543C1607.51 383.505 1606.97 383.21 1606.6 382.768C1606.23 382.323 1606.03 381.73 1606.07 381.092C1606.11 380.448 1606.39 379.883 1606.81 379.49C1607.23 379.095 1607.79 378.867 1608.4 378.909C1608.88 378.937 1609.31 379.104 1609.63 379.341L1609.65 379.096L1610.95 379.158ZM1609.46 381.975L1609.55 380.62C1609.29 380.215 1608.92 380.078 1608.54 380.055C1607.88 380.017 1607.37 380.526 1607.33 381.174C1607.29 381.806 1607.73 382.375 1608.39 382.412C1608.77 382.437 1609.17 382.352 1609.46 381.975Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1616.2 381.48L1616.07 383.879L1614.79 383.815L1614.9 381.574C1614.94 380.846 1614.61 380.456 1613.97 380.422C1613.64 380.4 1613.26 380.571 1612.92 380.923C1612.92 380.923 1612.89 381.613 1612.85 382.313C1612.81 383.007 1612.77 383.703 1612.77 383.703L1611.45 383.626C1611.45 383.626 1611.51 382.523 1611.58 381.424C1611.64 380.317 1611.7 379.211 1611.7 379.211L1613.02 379.291L1613 379.619C1613.36 379.35 1613.79 379.224 1614.28 379.25C1614.87 379.279 1615.36 379.514 1615.7 379.901C1616.04 380.289 1616.23 380.831 1616.2 381.48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1589.7 382.069L1588.35 381.954C1588.35 381.954 1588.19 381.116 1588.04 380.272C1587.9 379.432 1587.75 378.594 1587.75 378.594C1587.75 378.594 1587.2 379.37 1586.65 380.153C1586.11 380.932 1585.56 381.707 1585.56 381.707L1584.04 381.57C1584.04 381.57 1584.25 381.271 1584.57 380.821C1584.89 380.364 1585.31 379.763 1585.74 379.164C1586.16 378.557 1586.58 377.953 1586.89 377.499C1587.21 377.049 1587.42 376.749 1587.42 376.749L1587.11 374.922C1587.11 374.922 1586.82 375.334 1586.4 375.944C1585.97 376.554 1585.4 377.369 1584.84 378.183C1584.26 378.994 1583.69 379.808 1583.26 380.418C1582.83 381.028 1582.54 381.436 1582.54 381.436L1581.03 381.286C1581.03 381.286 1581.39 380.776 1581.94 380.007C1582.22 379.621 1582.53 379.167 1582.87 378.682C1583.22 378.204 1583.58 377.69 1583.94 377.172C1584.3 376.658 1584.66 376.141 1585 375.659C1585.34 375.176 1585.65 374.723 1585.92 374.336C1586.46 373.563 1586.82 373.053 1586.82 373.053L1588.14 373.171L1588.52 375.384L1589.88 375.496L1588.82 377.047C1588.82 377.047 1589.03 378.304 1589.25 379.561C1589.47 380.818 1589.7 382.069 1589.7 382.069Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1621.69 377.568C1621.69 377.568 1621.68 377.978 1621.64 378.593C1621.62 379.208 1621.58 380.033 1621.54 380.853C1621.51 381.677 1621.47 382.498 1621.44 383.113C1621.42 383.728 1621.4 384.139 1621.4 384.139L1620.06 384.08L1620.07 383.834C1619.72 384.033 1619.28 384.153 1618.79 384.131C1618.18 384.1 1617.64 383.811 1617.27 383.372C1616.89 382.933 1616.68 382.34 1616.71 381.697C1616.74 381.059 1617.01 380.494 1617.43 380.092C1617.85 379.694 1618.41 379.466 1619.02 379.49C1619.5 379.519 1619.93 379.672 1620.25 379.913L1620.37 377.503L1621.69 377.568ZM1620.13 382.545L1620.2 381.188C1619.94 380.776 1619.55 380.648 1619.17 380.63C1618.5 380.599 1618.01 381.113 1617.97 381.762C1617.94 382.411 1618.38 382.978 1619.05 383.009C1619.44 383.027 1619.83 382.938 1620.13 382.545Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1605.89 379.977C1605.6 379.99 1604.92 379.985 1604.48 380.505L1604.3 383.189L1602.99 383.098C1602.99 383.098 1603.06 382 1603.13 380.898C1603.21 379.797 1603.28 378.692 1603.28 378.692L1604.6 378.786L1604.57 379.117C1604.89 378.876 1605.35 378.75 1605.96 378.851",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_34_394",
    x: 0.333984,
    y: 0.655436,
    width: 2284.43,
    height: 439.694,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.91667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.8125
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.858824 0 0 0 0 0.34902 0 0 0 0 0.305882 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_34_394"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_34_394",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_34_394",
    x1: 1103.75,
    y1: 16.4887,
    x2: 1110.09,
    y2: -68.6481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_34_394",
    x1: 764.503,
    y1: 24.4143,
    x2: 758.311,
    y2: -59.6274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_34_394",
    x1: 764.503,
    y1: 26.3676,
    x2: 758.313,
    y2: -57.6661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_34_394",
    x1: 1030.75,
    y1: 479.466,
    x2: 837.474,
    y2: 199.184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC5C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_34_394",
    x1: 926.029,
    y1: 231.634,
    x2: 953.331,
    y2: 308.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#353740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#282A32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_34_394",
    x1: 911.275,
    y1: 364.375,
    x2: 814.729,
    y2: 593.681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D45151",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251326,
    stopColor: "#D45151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45151",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_34_394",
    x1: 852.561,
    y1: 336.699,
    x2: 852.561,
    y2: 337.178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_34_394",
    x1: 3.74293,
    y1: 0,
    x2: 3.74293,
    y2: 0.533228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_34_394",
    x1: 2.17354,
    y1: 0,
    x2: 2.17354,
    y2: 0.479167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_34_394",
    x1: 0.539502,
    y1: 0,
    x2: 0.539502,
    y2: 0.479167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_34_394",
    x1: 2.17354,
    y1: 0,
    x2: 2.17354,
    y2: 0.533228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_34_394",
    x1: 1043.74,
    y1: 355.031,
    x2: 1043.74,
    y2: 355.564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_34_394",
    x1: 994.494,
    y1: 145.059,
    x2: 994.494,
    y2: 331.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D45151",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45151"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_34_394",
    x1: 896.758,
    y1: 149.579,
    x2: 879.245,
    y2: 331.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D45151",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45151"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_34_394",
    x1: 885.459,
    y1: 149.578,
    x2: 867.946,
    y2: 331.489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D45151",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45151"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_34_394",
    x1: 995.059,
    y1: 189.125,
    x2: 1012.57,
    y2: 371.036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D45151",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45151"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_34_394",
    x1: 986.02,
    y1: 141.669,
    x2: 1003.53,
    y2: 323.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D45151",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45151"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_34_394",
    x1: 902.408,
    y1: 72.7461,
    x2: 884.895,
    y2: 254.657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D45151",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45151"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_34_394",
    x1: 951.48,
    y1: 335.892,
    x2: 1128.94,
    y2: 505.464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D94F55",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.138726,
    stopColor: "#D94F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.712096,
    stopColor: "#D94F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D94F55",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_34_394",
    x1: 875.409,
    y1: 530.22,
    x2: 839.267,
    y2: 607.673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D45151",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48081,
    stopColor: "#D45151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45151",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_34_394",
    x1: 1008.71,
    y1: 292.445,
    x2: 1028.96,
    y2: 326.239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D45151",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.337869,
    stopColor: "#D45151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D45151",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_34_394",
    x1: 1043.96,
    y1: 531.871,
    x2: 1128.79,
    y2: 651.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D94F55",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.138726,
    stopColor: "#D94F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.712096,
    stopColor: "#D94F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D94F55",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_34_394",
    x1: 960.259,
    y1: 50.4862,
    x2: 1187.33,
    y2: 238.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D94F55",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.138726,
    stopColor: "#D94F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.712096,
    stopColor: "#D94F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D94F55",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_34_394",
    x1: 903.787,
    y1: 50.4862,
    x2: 676.713,
    y2: 238.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D94F55",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.138726,
    stopColor: "#D94F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.712096,
    stopColor: "#D94F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D94F55",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgMd);
export default __webpack_public_path__ + "static/media/bg-md.22fdbb39155b451798dbae489065629c.svg";
export { ForwardRef as ReactComponent };